import { render, staticRenderFns } from "./ForumThreadGroup.vue?vue&type=template&id=0ee987af&scoped=true&"
import script from "./ForumThreadGroup.vue?vue&type=script&lang=js&"
export * from "./ForumThreadGroup.vue?vue&type=script&lang=js&"
import style0 from "./ForumThreadGroup.vue?vue&type=style&index=0&id=0ee987af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee987af",
  null
  
)

export default component.exports